import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import {
  FaChartLine,
  FaUserGraduate,
  FaCode,
  FaGraduationCap,
  FaCalendarWeek,
  FaPlayCircle,
  FaCheck
} from 'react-icons/fa';
import './BootcampOverview.css';

const BootcampOverview = ({ nextSessionDate }) => {
  const cohortDay = nextSessionDate?.dayOfWeek && !nextSessionDate.dayOfWeek.includes('TBD')
    ? nextSessionDate.dayOfWeek
    : 'Wednesday';
  const cohortTime = nextSessionDate?.time && !nextSessionDate.time.includes('TBD')
    ? nextSessionDate.time
    : '7:00 PM Eastern';

  const targetAudience = [
    {
      icon: <FaChartLine />,
      title: 'Investors with strategy ideas',
      description: 'who want to turn them into testable BotSpot workflows.'
    },
    {
      icon: <FaUserGraduate />,
      title: 'Non-coders ready to learn',
      description: 'AI-assisted investing workflows without writing Python from scratch.'
    },
    {
      icon: <FaCode />,
      title: 'Developers looking to supercharge',
      description: 'their research and strategy-building workflow with AI.'
    }
  ];

  // Simplified overview - just key highlights
  const overviewHighlights = [
    {
      icon: <FaCalendarWeek />,
      title: '5 Live Classes',
      subtitle: `${cohortDay}s`,
      description: 'Covering stocks, crypto, options, and futures workflows.',
      bullets: [
        'Hands-on demos of building and testing AI-assisted workflows on BotSpot.trade',
        'Learn professional vibe coding using VS Code with Copilot and Cursor',
        'Interactive Q&A each session to tackle your specific questions',
        'Live build sessions where you build practical strategy workflows together',
        'Master both our proprietary tools and industry-standard development environments',
        'Weekly homework assignments to reinforce learning',
        'Direct access to instructors during each 60-minute session',
        'Small cohort sizes for personalized attention and support'
      ]
    },
    {
      icon: <FaPlayCircle />,
      title: 'Bootcamp Recordings and Materials',
      subtitle: 'Replay the training',
      description: 'Use the course portal to revisit available lessons and supporting materials.',
      bullets: [
        'Recorded lessons from available Bootcamp sessions',
        'Course materials and resources in the Bootcamp portal',
        'Replay access for catching up or reviewing hard sections',
        'Summaries and chapters as the recording automation rolls out',
        'Self-paced buyers can upgrade later when they want live help'
      ]
    }
  ];

  return (
    <div className="bootcamp-overview">
      <Container>
        {/* Who Is This For Section - Visual Cards */}
        <Row className="justify-content-center mb-5">
          <Col lg={10}>
            <div className="bootcamp-overview-section">
              <h2 className="bootcamp-overview-title">
                Who Is This For?
              </h2>

              <Row className="g-4">
                {targetAudience.map((audience, index) => (
                  <Col md={4} key={index}>
                    <Card className="bootcamp-audience-card h-100">
                      <Card.Body className="text-center">
                        <div className="bootcamp-audience-icon">
                          {audience.icon}
                        </div>
                        <h4 className="bootcamp-audience-title">
                          {audience.title}
                        </h4>
                        <p className="bootcamp-audience-description">
                          {audience.description}
                        </p>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </div>
          </Col>
        </Row>

        {/* Simplified Bootcamp Overview */}
        <Row className="justify-content-center">
          <Col lg={10}>
            <div className="bootcamp-overview-section">
              <h2 className="bootcamp-overview-title">
                <FaGraduationCap className="me-3" />
                Bootcamp Overview
              </h2>

              <div className="bootcamp-overview-intro">
                <p>
                  When you join, you get <strong>5 weeks of live, hands-on training</strong> ({cohortDay}s at {cohortTime})
                  plus access to available <strong>recordings and materials</strong> through the Bootcamp portal.
                </p>
              </div>

              <Row className="g-4">
                {overviewHighlights.map((item, index) => (
                  <Col lg={6} key={index}>
                    <Card className="bootcamp-feature-card h-100">
                      <Card.Body>
                        <div className="bootcamp-feature-header">
                          <div className="bootcamp-feature-icon">
                            {item.icon}
                          </div>
                          <h4 className="bootcamp-feature-title">
                            {item.title}
                          </h4>
                        </div>
                        <p className="bootcamp-feature-description">
                          {item.description}
                        </p>
                        <ul className="bootcamp-feature-bullets">
                          {item.bullets.map((bullet, i) => (
                            <li key={i}>
                              <FaCheck className="bullet-check" />
                              {bullet}
                            </li>
                          ))}
                        </ul>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BootcampOverview;
